import { getColorValue } from '@library/utils/helpers/functions/getColorVariable';
import { Plugin } from 'chart.js';

declare module 'chart.js' {
  interface Chart {
    verticalLiner: {
      draw: boolean;
    }
  }
}

export const VerticalLinePlugin: Plugin = {
  id: 'vertical-line',
  afterInit: (chart) => {
    chart.verticalLiner = {draw: false};
  },
  afterEvent: (chart, args) => {
    const {inChartArea} = args;
    chart.verticalLiner = {draw: inChartArea};
  },
  beforeTooltipDraw: (chart, args) => {
    const { draw } = chart.verticalLiner;

    if (!draw) {
      return;
    }

    const { ctx } = chart;
    const { top, bottom } = chart.chartArea;
    const { tooltip } = args;
    const x = tooltip?.caretX;

    if (!x) {
      return;
    }

    ctx.save();

    ctx.strokeStyle = getColorValue('--grey-50');
    ctx.setLineDash([5, 5]);

    ctx.beginPath();
    ctx.moveTo(x, top);
    ctx.lineTo(x, bottom);
    ctx.stroke();

    ctx.restore();
  }
};
